import { Enrolment } from '@/models/enrolment';

export class EnrolmentsReplacedEventPayload {
	public constructor(public readonly selectedEnrolments: Readonly<Enrolment[]>) {}
}
